import React from 'react';
import { breakpoints, colors } from '../config';

const SubTitle = ({ children, ...rest }) => (
  <h3 {...rest}>
    {children}

    <style jsx>{`
      h3 {
        font-family: ${colors.baseFontDisplay};
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        margin-bottom: 5px;
        margin-top: 32px;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        width: 300px;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        /*h3 {
          font-family: ${colors.baseFontDisplay};
        }*/
      }
    `}</style>
  </h3>
);

export default SubTitle;
